import"./../ContentModule/ContentModule.css.ts.vanilla.css";import"./SplashPage.css.ts.vanilla.css";var a="_1ay5pdg0";export{a as splashPageOverlay};
